// Job Categories
const jobcategories = [
    {
        id: '1',
        icon: 'https://cdn.lordicon.com/xulniijg.json',
        name: 'Business Development',
        position: '102'
    },
    {
        id: '2',
        icon: 'https://cdn.lordicon.com/oclwxpmm.json',
        name: 'Automotive Jobs',
        position: '64'
    },
    {
        id: '3',
        icon: 'https://cdn.lordicon.com/dklbhvrt.json',
        name: 'Construction / Facilities',
        position: '35'
    },
    {
        id: '4',
        icon: 'https://cdn.lordicon.com/adwosptt.json',
        name: 'Design, Art & Multimedia',
        position: '49'
    },
    {
        id: '5',
        icon: 'https://cdn.lordicon.com/kkcllwsu.json',
        name: 'Healthcare',
        position: '97'
    },
    {
        id: '6',
        icon: 'https://cdn.lordicon.com/rahcoaeu.json',
        name: 'Sales & Marketing',
        position: '312'
    },
    {
        id: '7',
        icon: 'https://cdn.lordicon.com/smauprql.json',
        name: 'Accounting / Finance',
        position: '62'
    },
    {
        id: '8',
        icon: 'https://cdn.lordicon.com/itykargr.json',
        name: 'Project Management',
        position: '35'
    },
    {
        id: '9',
        icon: 'https://cdn.lordicon.com/cnyeuzxc.json',
        name: 'Costomer Services',
        position: '35'
    },
    {
        id: '10',
        icon: 'https://cdn.lordicon.com/sygggnra.json',
        name: 'Content Writer',
        position: '746'
    },
    {
        id: '11',
        icon: 'https://cdn.lordicon.com/hfmdczge.json',
        name: 'Government Jobs',
        position: '642'
    },
    {
        id: '12',
        icon: 'https://cdn.lordicon.com/xhebrhsj.json',
        name: 'Digital Marketing',
        position: '364'
    },
    {
        id: '13',
        icon: 'https://cdn.lordicon.com/ucvsemjq.json',
        name: 'Education & training',
        position: '35'
    },
    {
        id: '14',
        icon: 'https://cdn.lordicon.com/pvbjsfif.json',
        name: 'IT & Software',
        position: '35'
    },
    {
        id: '15',
        icon: 'https://cdn.lordicon.com/auvicynv.json',
        name: 'Catering & Tourism',
        position: '35'
    },
]
export { jobcategories }